<template>
  <button class="base-button" :class="className" :disabled="disabled || loading">
    <span class="base-button__title" v-if="title">{{ title }}</span>
    <BaseIcon class="base-button__icon" v-if="icon" :name="icon" :useImgNotSvg="useImgNotSvg"/>
    <div v-show="loading" class="base-button__spinner">
      <BaseIcon name="spinner"></BaseIcon>
    </div>
  </button>
</template>

<script>
export default {
  props: {
    title: String,
    icon: String,
    disabled: Boolean,
    theme: String,
    loading: Boolean,
    useImgNotSvg: Boolean
  },
  computed: {
    className () {
      return [
        this.disabled ? 'base-button--disabled' : '',
        this.loading ? 'base-button--loading' : '',
        this.theme ? `base-button--${this.theme}` : ''
      ]
    }
  },
}
</script>

<style lang="scss">
  @import './base-button.scss';

  .base-button {
    @include base-button;
  }
</style>



// WEBPACK FOOTER //
// src/components/base/BaseButton.vue